import React from "react";
import styled from "@emotion/styled";
import { useSwiper } from "swiper/react";
import PropTypes from "prop-types";

const SliderArrows = ({ onNext, onPrev }) => {
	const swiper = useSwiper();

	const toggleNext = () => {
		if (onNext) {
			return onNext();
		}
		return swiper.slideNext();
	};

	const togglePrev = () => {
		if (onPrev) {
			return onPrev();
		}
		return swiper.slidePrev();
	};
	return (
		<Container className="swiper-button-container">
			<PrevArrow
				className="swiper-button-prev"
				onClick={togglePrev}
				aria-label="Previous Slide"
			> Previous Slide</PrevArrow>
			<NextArrow
				className="swiper-button-next"
				onClick={toggleNext}
				aria-label="Next Slide"> Next Slide</NextArrow>
			
		</Container>
	);
};

export default SliderArrows;

SliderArrows.propTypes = {
	onNext: PropTypes.func,
	onPrev: PropTypes.func,
};

const Container = styled.div`
	align-self: flex-end;
	width: fit-content;
	display: flex;
	gap: 6rem;
`;

const Arrow = styled.button`
	background: none !important;
	padding: 0;
	height: 32px;
	width: 24px;
	display: flex;
	align-items: center;
	position: relative;
	opacity: 1;
	cursor: pointer;
	border: none;
	color: transparent;

	&::after {
		background-repeat: no-repeat;
		background-size: contain;
		width: 50%;
		height: 24px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	&:hover,
	&:focus {
		background: none !important;
		box-shadow: none !important;
	}
	&:focus-visible {
		&::after {
			outline: 2px solid #0079c1;
			outline-offset: 2px;
			border-radius: 5px;
		}
	}

	&:disabled {
		opacity: 0.5;
		cursor: default;
	}
`;

const PrevArrow = styled(Arrow)`
	&::after {
		content: "";
		transition: all 0.2s ease-in;
		background-image: url(${mainScript.assetPath +
		"images/svg/icons/icon-slider-arrow-left.svg"});
	}
`;

const NextArrow = styled(Arrow)`
	&::after {
		content: "";
		transition: all 0.2s ease-in;
		background-image: url(${mainScript.assetPath +
		"images/svg/icons/icon-slider-arrow-right.svg"});
	}
`;
